import React from 'react';
import styled, { keyframes } from 'styled-components';

interface ISkeletonBlockProps {
  height?: number | string;
  width?: number | string;
  radius?: number;
  inline?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const shimmer = keyframes`
  0%   { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
`;

const Block = styled.span<{
  $height: string;
  $width: string;
  $radius: number;
  $inline: boolean;
}>`
  display: ${({ $inline }) => ($inline ? 'inline-block' : 'block')};
  height: ${({ $height }) => $height};
  width: ${({ $width }) => $width};
  border-radius: ${({ $radius }) => $radius}px;
  background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 37%, #f2f2f2 63%);
  background-size: 400% 100%;
  animation: ${shimmer} 1.4s ease infinite;
  vertical-align: middle;
`;

const toCss = (v: number | string | undefined, fallback: string): string => {
  if (v === undefined) {
    return fallback;
  }

  return typeof v === 'number' ? `${v}px` : v;
};

const SkeletonBlock: React.FC<ISkeletonBlockProps> = ({
  height,
  width,
  radius = 4,
  inline = false,
  className,
  style
}) => (
  <Block
    $height={toCss(height, '14px')}
    $width={toCss(width, '100%')}
    $radius={radius}
    $inline={inline}
    className={className}
    style={style}
  />
);

export default SkeletonBlock;
